module.exports = __webpack_public_path__ + "img/blue-shaded-like.675c7f25.svg";